export const validateState = (expectedStates, currentState) => {
    if (!expectedStates.includes(currentState)) {
        throw new Error(`Expected the state to be ${expectedStates
            .map((expectedState) => `"${expectedState}"`)
            .join(' or ')} but it was "${currentState}".`);
    }
};
